import React from "react";
import { ReactSVG } from "react-svg";
import info from "../../images/info.svg";
import { SimpleTooltip } from "../SimpleTooltip";
import { strings } from "../../strings/strings";
import { translit } from "../../utils/utils";

export const InfoView = ({
    orangeText = strings.infoView.text2
}: {
    orangeText?: string
}) => {
    return (
        <SimpleTooltip id={translit(strings.infoView.text1)} title={
            <span>{strings.infoView.text1}<span
                className={"accent"}>{orangeText}</span>{strings.infoView.text3}</span>}
            placement={"top"}>
            {<ReactSVG src={info} />}
        </SimpleTooltip>
    )
}